"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.borderRadiusSelector = void 0;
var borderRadiusSelector = function (props, size) {
    if (size === "lg") {
        return props.theme.variables.main.borderRadiusLg;
    }
    return props.theme.variables.main.borderRadius;
};
exports.borderRadiusSelector = borderRadiusSelector;
var getBorderRadius = function (size) {
    if (size === void 0) { size = "md"; }
    return function (props) { return exports.borderRadiusSelector(props, size); };
};
exports.default = getBorderRadius;
//# sourceMappingURL=index.js.map